<div>

  <div class="modal-header">
    <button (click)="onClose()" class="close close-lg pull-right">&times;</button>
    <h1>Message Content Preview</h1>
  </div>

  <div class="modal-body">
    <div style="width: 100%;">
      &nbsp;
      <img [hidden]="loaded"
           src="/img/loading.gif" style="width: 32px;"/>
    </div>

    <div *ngIf="messageContent$ | async as messageContent">

      <div *ngIf="messages.length < 0 || !loaded" class="error"
           style="padding: 20px; vertical-align:middle; height: 100px;">
        No message was sent. If the message is for an appointment confirmed before this message should be sent then no message will be sent.
      </div>

      <!-- this is also working

      iframe *ngIf="mediaType === 'email'"
              [srcdoc]="innerHtml  | safe: 'html'"
              style="width: 100%; height: 500px"></iframe -->
        <div *ngIf="mediaType === 'email' && isPreview"
             id="printdiv"
             [innerHtml]="innerHtml  | safe: 'html'"
             style="width: 100%; height: 500px; overflow-y: scroll">
        </div>

        <ng-sms-message *ngIf="mediaType === 'sms' && isPreview"
          [message]="messageContent.message.__text"
          editable="false">
      </ng-sms-message>

      <voice-message *ngIf="mediaType === 'voice' && messages.length > 0 && isPreview"
                         [messages]="messages"
                         [uuid]="messageUuid"></voice-message>

      <textarea
                *ngIf="!isPreview && messages.length > 0"
                style="width: 100%; height: 500px"
                rows=""
                cols=""
                readonly
                [ngModel]="contentSource">
      </textarea>
    </div>
  </div>

  <div class="modal-footer">
  <div *ngIf="isAuthenticatedFromAdmin$ | async"></div>
    <div>
      <div class="btn-group pull-left" role="group"
           *ngIf="isAuthenticatedFromAdmin && messages.length > 0">
        <button type="button" class="btn"
                [ngClass]="{'btn-default' : !isPreview, 'btn-primary' : isPreview}"
                (click)="changeView(true)">Preview
        </button>
        <button type="button" class="btn"
                [ngClass]="{'btn-default' : isPreview, 'btn-primary' : !isPreview}"
                (click)="changeView(false)">Source
        </button>
      </div>

      <div class="btn-group pull-right" role="group">
        <button type="button" class="btn btn-default"
                              printSectionId="printdiv"
                              ngxPrint
                             [disabled]="!isPreview"
                             *ngIf="mediaType !== 'voice' && messages.length > 0  && isAuthenticatedFromAdmin">Print
        </button>
        <button type="button"
                class="btn btn-default"
                (click)="onClose()"
        >Close
        </button>
      </div>
    </div>
  </div>


</div>